module.exports = __webpack_public_path__ + "static/img/dhanesh_img.19d95dd5.png";